module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vpelv8-c8e177502898e8a3b3edefec34f1af77.jpg";